import { cameraTypeList, existingEquipmentCameras, existingEquipmentVulcan, existingEquipmentWiredSensors, existingEquipmentWirelessSensors, secureBusinessPlanVulcan, tsbTerm } from '../../utils/constant';
import { disableOptions } from '../vulcanPricing/utils/utils';
import { secureBusinessOffersVulcan } from '../vulcanPricing/secureBusiness/secureBusinessFieldNames';
import { getLocale } from '../../misc';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

// This function takes opt arguments which are equipment section fields
export const getControlIncludedCameraTotal = opt => {
  let returnObj = 0;
  const formObjectKeys = Object.keys(opt);
  const sectionSum = formObjectKeys
    .filter(k => cameraTypeList.includes(opt[k].productType))
    .reduce((acc, k) => acc + parseInt(opt[k].value || 0, 10), 0);
  returnObj = sectionSum;

  return returnObj; // Ensure returnObj is always returned
};

export const SecureBusinessHelpers = ({ fieldName, formFields, fields, orderData }) => {
  const locale = getLocale();
  const {
    vulcanWebform: {
      vulTenDollarBundleDiscountTSB,
      vulFifteenDollarMonthlyDiscountTSB,
      vulSmartCameraTSB,
      vulMonitorTSB,
      vulSixtyMonth,
      vulThirtyMonth
    }
  } = locale === 'en-US' ? EN : FR;

  if (
    fieldName === secureBusinessOffersVulcan &&
    formFields[secureBusinessPlanVulcan].value
  ) {

    const isSmartCameraPlanSlected =
      formFields[secureBusinessPlanVulcan].value === vulSmartCameraTSB;

    if (isSmartCameraPlanSlected) {
      formFields[secureBusinessOffersVulcan].options = fields.options.filter(
        data =>
          ![
            vulTenDollarBundleDiscountTSB,
            vulFifteenDollarMonthlyDiscountTSB
          ].includes(data.fields.value)
      );

      return {
        hide: false,
        update: true,
        filteredOptions: formFields[secureBusinessOffersVulcan].options.filter(
          data =>
            ![
              vulTenDollarBundleDiscountTSB,
              vulFifteenDollarMonthlyDiscountTSB
            ].includes(data.fields.value)
        )
      };
    }

    formFields[secureBusinessOffersVulcan].options = fields.options;
    // Wireline: do not disable $10 Bundle Discount (user can select it; it is not preselected). Vulcan: disable both.
    const optionsToDisable = orderData.isThisVulcanOrder
      ? [vulTenDollarBundleDiscountTSB, vulFifteenDollarMonthlyDiscountTSB]
      : [vulFifteenDollarMonthlyDiscountTSB];
    disableOptions(
      formFields[secureBusinessOffersVulcan].options,
      optionsToDisable,
      true
    );
  }

  if (fieldName === tsbTerm && orderData.isThisVulcanOrder) {
      fields.options = formFields[fieldName].options.filter(
        data => data.fields.value !== vulSixtyMonth
      );
      formFields[fieldName].value = vulThirtyMonth;
  }

  if (fieldName === secureBusinessPlanVulcan) {
    const optionsSecureBusinessPlan = formFields[fieldName].options || [];

    if (orderData.isThisVulcanOrder) {
      fields.options = optionsSecureBusinessPlan.filter(
        data => data.fields.value !== vulSmartCameraTSB
      );
    }

    const existingEquipmentValue = formFields[existingEquipmentVulcan];
    if (existingEquipmentValue) {
      const wiredField = existingEquipmentValue[existingEquipmentWiredSensors];
      const wirelessField = existingEquipmentValue[existingEquipmentWirelessSensors];
      const camerasField = existingEquipmentValue[existingEquipmentCameras];
      const wired = Number(wiredField && wiredField.value) || 0;
      const wireless = Number(wirelessField && wirelessField.value) || 0;
      const cameras = Number(camerasField && camerasField.value) || 0;

      const hasSensors = wired > 0 || wireless > 0;
      const hasCameras = cameras > 0;

      let excludeValues = [];
      if (hasSensors && hasCameras) {
        excludeValues = [vulSmartCameraTSB, vulMonitorTSB];
      } else if (hasSensors) {
        excludeValues = [vulSmartCameraTSB];
      } else if (hasCameras) {
        excludeValues = [vulMonitorTSB];
      }

      if (excludeValues.length > 0) {
        if (excludeValues.includes(formFields[fieldName].value)) {
          formFields[fieldName].value = ''; // reset the value if it's in the excluded list
        }
        return {
          hide: false,
          update: true,
          filteredOptions: optionsSecureBusinessPlan.filter(
            data => !excludeValues.includes(data.fields.value)
          )
        };
      }
    }
  }

  return { hide: false };

};
